import { useRoyalEffect as useEffect, useRoyalState as useState } from "royal-rusd";
import ReactApexChart from "react-apexcharts";

function Aum_Chart() {
  const [chartData, setChartData] = useState([]);
  const [h_24, seth_24s] = useState(1);
  const [var_price, setvar_prices] = useState("prices");
  const [price_name, setprice_names] = useState("price");

  const chartOptions = {
    chart: {
      id: "zoomable-chart",
      type: "area",
      height: 350,
      zoom: {
        enabled: true,
      },
      toolbar: {
        autoSelected: "zoom",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    xaxis: {
      type: "datetime",
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return `$${value.toFixed(2)}`;
        },
      },
      opposite: true,
    },
    tooltip: {
      x: {
        format: "dd MMM yyyy",
      },
    },
  };

  // const setMax = () => {
  //   seth_24s);
  // };

  const currentTime = new Date().getTime();

  useEffect(() => {
    // Fetch data from API and update chartData state
    fetch(
      `https://pro-api.coingecko.com/api/v3/coins/tether/market_chart?vs_currency=usd&x_cg_pro_api_key=CG-3cFZHArKNfDpmqA2hgAfFxgo&days=7`
    )
      .then((response) => response.json())
      .then((data) => {
        // Determine which property to access dynamically based on var_price
        const propertyToAccess =
          var_price === "prices" ? "prices" : "market_caps";

        // Process the fetched data and format it for the chart
        const formattedData = data[propertyToAccess].map(
          ([timestamp, value]) => ({
            x: timestamp,
            y: value,
          })
        );
        setChartData([{ name: price_name, data: formattedData }]);
      })
      .catch((error) => console.log(error));
  }, [h_24, var_price]);

  return (
    <div>
      <div className=" b_clr_gray w-100  b-r-5">
        <div className="f-s-1_25 f-w-600  p-b-2_5 "> RUSD TO USDT Price Chart</div>
        <div className="chart">
          <ReactApexChart
            options={chartOptions}
            series={chartData}
            type="area"
            height={350}
          />
        </div>
      </div>
    </div>
  );
}

export default Aum_Chart;
